import { Tooltip, UnstyledButton } from "@mantine/core";
import { motion } from "framer-motion";

import { MenuOption } from "@/types/pages/dashboard";
import { DURATION_SM } from "@/lib/animation/motion";
import styles from "./styles.module.scss";

const MotionUnstyledButton = motion.create(UnstyledButton);

interface SideBarOptionIconProps {
  handleClick: () => void;
  option: MenuOption;
  selectedMenuOption: string;
}

export function SideBarOptionIcon({
  option,
  handleClick,
  selectedMenuOption,
}: SideBarOptionIconProps) {
  return (
    <Tooltip label={option.label} withArrow position="right">
      <MotionUnstyledButton
        className={`${styles.iconButton} ${
          option.label === selectedMenuOption ? styles.selectedIconButton : ""
        }`}
        onClick={handleClick}
        whileHover={{ y: -2, opacity: 0.85 }}
        transition={{ duration: DURATION_SM }}
      >
        {option.icon}
      </MotionUnstyledButton>
    </Tooltip>
  );
}
